export class VoucherCategory {
    id = null;
    name = null;
    code = null;
    description = null;
}